import React from "react"
import {
    Card,
    CardBody,
    Col,
    Row,
    Button
} from "reactstrap"
import VerticalLayout from "../VerticalLayout/index"

const AdminProfile = () => {
    return (
        <div style={{ marginTop: "70px" }}>
            <VerticalLayout>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Row className="mb-3 col-md-10">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        First Name
                                    </label>
                                    <div className="col-md-7">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Type here..."
                                        />
                                    </div>
                                </Row>
                                <Row className="mb-3 col-md-10">
                                    <label
                                        className="col-md-2 col-form-label"
                                        htmlFor="example-search-input"
                                    >
                                        Last Name
                                    </label>
                                    <div className="col-md-7">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Type here..."
                                        />
                                    </div>
                                </Row>
                                <Row className="mb-3 col-md-10">
                                    <label
                                        htmlFor="example-email-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Email
                                    </label>
                                    <div className="col-md-7">
                                        <input
                                            className="form-control"
                                            type="email"
                                            placeholder="Type here..."
                                        />
                                    </div>
                                </Row>

                                <Row className="mb-3 col-md-10">
                                    <label
                                        htmlFor="example-number-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Mobile
                                    </label>
                                    <div className="col-md-7">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Type here..."
                                            id="example-number-input"
                                        />
                                    </div>
                                </Row>

                                <Row className="mb-3 col-md-10">
                                    <label
                                        htmlFor="example-number-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Password Reset
                                    </label>
                                    <div className="col-md-7">
                                        <input
                                            className="form-control"
                                            type="password"
                                            placeholder="Type here..."
                                            id="example-number-input"
                                        />
                                    </div>
                                </Row>
                                <Button>Submit</Button>
                            </CardBody>

                        </Card>
                    </Col>
                </Row>
            </VerticalLayout>
        </div>
    )
}

export default AdminProfile
